export default "__VITE_ASSET__DTsnK$3m__"